import { Button, useMediaQuery, useTheme } from '@mui/material';
import { Trans } from '@lingui/macro';

import { ListButtonsColumn } from '../../../../modules/dashboard/lists/ListButtonsColumn';
import { useModalContext } from '../../../../hooks/useModal';

export interface ILeverageActionsProps {
  tokenId?: string;
}

export const SuppliedActions = ({ tokenId }: ILeverageActionsProps) => {
  const { breakpoints } = useTheme();
  const md = useMediaQuery(breakpoints.up('md'));
  return md ? (
    <ListButtonsColumn size="small">
      <WithdrawButton tokenId={tokenId} />
    </ListButtonsColumn>
  ) : (
    <WithdrawButton tokenId={tokenId} />
  );
};

const WithdrawButton = ({ tokenId }: ILeverageActionsProps) => {
  const { openWithdrawPosition } = useModalContext();
  return (
    <Button
      variant="contained"
      onClick={() => {
        tokenId && openWithdrawPosition(tokenId);
        window.gtag('event', 'lending_withdraw_click', {
          asset: 'Uniswap position',
        });
      }}
    >
      <Trans>Withdraw</Trans>
    </Button>
  );
};
